import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Media",
      slug:"/media"
    }
  ]
}

export default function MediaBanner() {
  return (
    <>
      <section className="media-banner header-gap">
        <div className="banner-image">
          <img
            className="img-responsive"
            src="./assets/home/media-banner.webp"
            alt="logo"
          />
          <Breadcrumb breadcrumbData={breadcrumbData}/>
        </div>
      </section>
    </>
  );
}
